import HeaderPaddingMain from '@/views/layout/HeaderPaddingMain.vue';
var router = [{
  path: '/setting',
  component: HeaderPaddingMain,
  name: 'setting',
  meta: {
    title: '基础设置',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/setting/BaseInfo.vue');
    }
  }]
}, {
  path: '/schoolSubject',
  component: HeaderPaddingMain,
  name: 'schoolSubject',
  meta: {
    title: '特色课程列表',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/setting/SchoolSubject.vue');
    }
  }]
}];
export default router;